import type { Breadcrumb } from "@/common/types/types";
import { BackgroundVisitUploadPanel } from "@/components/ui/BackgroundVisitUploadPanel";
import { OpenBackgroundVisitUploadButton } from "@/components/ui/BackgroundVisitUploadPanel/OpenBackgroundVisitUploadButton";
import { Button } from "@/components/ui/button";
import { SidebarTrigger } from "@/components/ui/sidebar";
import { Link } from "@tanstack/react-router";
import { AnimatePresence, motion } from "framer-motion";
import { ChevronRight } from "lucide-react";
import { useState } from "react";

interface NavbarProps {
  title: string;
  breadcrumbs?: Breadcrumb[];
  icon?: React.ReactNode;
  iconHandler?: () => void;
}

export const Navbar: React.FC<NavbarProps> = ({
  title,
  breadcrumbs,
  icon,
  iconHandler,
}) => {
  const [openBackgroundVisitPanel, setOpenBackgroundVisitPanel] =
    useState(false);

  return (
    <header className="flex items-center px-6 py-4 border-b">
      <SidebarTrigger className="md:hidden mr-4" />
      <div className="w-full flex flex-col justify-between gap-2">
        <div className="w-full flex items-center justify-between">
          <div className="flex items-center">
            {!breadcrumbs ? (
              <h1 className="text-lg font-bold text-primary">{title}</h1>
            ) : (
              breadcrumbs?.map((breadcrumb, index) => (
                <Link
                  key={index}
                  className="text-lg font-bold text-primary flex items-center "
                  to={breadcrumb.href}
                >
                  {index !== 0 && <ChevronRight size={18} />}
                  {breadcrumb.name}
                </Link>
              ))
            )}
          </div>
          {icon && (
            <Button
              className="flex items-center h-6 w-6"
              variant="ghost"
              onClick={iconHandler}
            >
              {/* TO-DO implement a tooltip here to help the user understand what the cloud is for */}
              {icon}
            </Button>
          )}
          <OpenBackgroundVisitUploadButton
            isOpen={openBackgroundVisitPanel}
            onOpenChange={(value) => {
              setOpenBackgroundVisitPanel(value);
            }}
          />
        </div>
        <AnimatePresence initial={false}>
          {openBackgroundVisitPanel && (
            <motion.div
              key="background-visit-panel"
              animate={{ height: "auto", opacity: 1 }}
              className="overflow-hidden"
              exit={{ height: 0, opacity: 0 }}
              initial={{ height: 0, opacity: 0 }}
              transition={{ duration: 0.3, ease: "easeInOut" }}
            >
              <BackgroundVisitUploadPanel />
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </header>
  );
};
